<nf-table-layout
  [autoResizeGrid]="false"
  [data]="data"
  [gridOptions]="gridOptions"
  hideClearAll
  hideTitle
></nf-table-layout>
